import React from "react";

export default function MembershipSummary({
  mode = "start",
  reason = "change",
}) {
  const isUpdatePayment = mode === "updatePayment";
  const isFailedRecovery = isUpdatePayment && reason === "failed";

  const title = isFailedRecovery
  ? "UPDATE CARD"
  : isUpdatePayment
  ? "CHANGE CARD"
  : "ADD CARD";

const subheading = isFailedRecovery
  ? "Replace your reservation card"
  : isUpdatePayment
  ? "Choose a new reservation card"
  : "Restore reservation access";

const text = isFailedRecovery
  ? "Choose a new card to restore reservation access. If there’s an outstanding late-cancel or no-show fee, it may be charged after your card is updated."
  : isUpdatePayment
  ? "Choose the card you want to use for future reservations. You won’t be charged today."
  : "Your account now requires a card for future reservations. Add one to start reserving again.";
  
  return (
    <section aria-label="Membership details" style={S.card}>
      <div style={S.head}>OVERVIEW</div>

      <div style={S.titleBlock}>
        <h2 style={S.title}>{title}</h2>
        <div style={S.subheading}>{subheading}</div>
        <p style={S.text}>{text}</p>
      </div>
    </section>
  );
}

const S = {
  card: {
    background: "#fff",
    borderRadius: 16,
    margin: "0 6px 16px",
    width: "calc(100% - 16px)",
    boxSizing: "border-box",
    color: "#0B0B0B",
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },

  head: {
    padding: "14px 16px 0px",
    fontSize: 12,
    fontWeight: 800,
    marginBottom: 12,
    color: "#6B7280",
    letterSpacing: 0.3,
    textTransform: "uppercase",
  },

  titleBlock: {
    padding: "0 16px 8px",
  },

  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 900,
    lineHeight: 1.15,
    letterSpacing: -0.1,
    color: "#0B0B0B",
  },

  subheading: {
    marginTop: 6,
    fontSize: 13,
    fontWeight: 800,
    lineHeight: 1.25,
    color: "#111",
    letterSpacing: -0.1,
  },

  text: {
    margin: "6px 0 0",
    fontSize: 13,
    color: "#555",
    fontWeight: 500,
    lineHeight: 1.5,
  },
};